import { useDirectionStore } from '@/store/directionStore'
import { Sidebar } from '@/components/layout/Sidebar'
import { CommandSidebar } from './CommandSidebar'
import { SaasSidebar } from './SaasSidebar'
import { ExpressiveSidebar } from './ExpressiveSidebar'

export { useShellLayout } from './useShellLayout'

export function DirectionalSidebar() {
  const d = useDirectionStore(s => s.direction)
  if (d === 'command') return <CommandSidebar />
  if (d === 'saas') return <SaasSidebar />
  if (d === 'expressive') return <ExpressiveSidebar />
  return <Sidebar />
}
